import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/pages.css";
import cookiesImg from "../assets/cookies.png";
import { useLanguage } from '../context/LanguageContext';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const { language } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setTimeout(() => setVisible(true), 500);
    } else if (consent === "true") {
      enableAnalytics();
    }
  }, []);

  const enableAnalytics = () => {
    if (!window.gtag) {
      const script = document.createElement("script");
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-24VTR24ER";
      script.async = true;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      gtag("js", new Date());
      gtag("config", "G-XXXXXXXXXX");
    }
  };

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "true");
    enableAnalytics();
    setVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookieConsent", "declined");
    setVisible(false);

    document.cookie.split(";").forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 2500 00:00:00 GMT;path=/`;
    });
  };

  if (!visible) return null;

  return (
    <div className="cookie-popup animate-slide-up">
      <div
        className="cookie-image-container"
        style={{ textAlign: "center", marginBottom: "10px" }}
      >
        <img
          src={cookiesImg}
          alt="Cookies Icon"
          className="cookie-icon"
          style={{
            width: "70px",
            height: "70px",
            margin: "0 auto",
            display: "block",
            objectFit: "contain",
          }}
        />
      </div>

      <h4
        className="cookie-title"
        style={{ textAlign: "center", marginBottom: "10px" }}
      >
        {language === 'nl' ? 'Cookies & Privacy' : 'Cookies & Privacy'}
      </h4>

      <p className="cookie-text" style={{ textAlign: "center" }}>
        {language === 'nl' 
          ? 'Wij gebruiken cookies om uw ervaring te verbeteren en verkeer te analyseren. '
          : 'We use cookies to enhance your experience and analyze traffic. '}
        <Link to="/cookie-policy" className="cookie-link">
          {language === 'nl' ? 'Meer informatie' : 'Learn more'}
        </Link>
      </p>

      <div
        className="cookie-actions"
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "12px",
          marginTop: "15px",
        }}
      >
        <button className="btn-accept" onClick={acceptCookies}>
          {language === 'nl' ? 'Accepteren' : 'Accept'}
        </button>
        <button className="btn-decline" onClick={declineCookies}>
          {language === 'nl' ? 'Weigeren' : 'Decline'}
        </button>
      </div>
    </div>
  );
}
